import { shippingDefaultDimenstions } from '../../config/configExtras';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { OWN, RESPONSE, SB_MARKET } from '../../util/enums';

// ================ Action types ================ //

const SAVE_WEIGHT_REQUEST = 'app/ShippingDetailsPage/SAVE_WEIGHT_REQUEST';
const SAVE_WEIGHT_SUCCESS = 'app/ShippingDetailsPage/SAVE_WEIGHT_SUCCESS';
const SAVE_WEIGHT_ERROR = 'app/ShippingDetailsPage/SAVE_WEIGHT_ERROR';

const CLEAR_FORM = 'app/ShippingDetailsPage/CLEAR_FORM';

// ================ Reducer ================ //

const initialState = {
  saveWeightSuccess: false,
  saveWeightInProgress: false,
  saveWeightError: null,

  clearForm: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SAVE_WEIGHT_REQUEST:
      return { ...state, saveWeightInProgress: true, saveWeightError: null };
    case SAVE_WEIGHT_SUCCESS:
      return { ...state, saveWeightInProgress: false, saveWeightSuccess: true };
    case SAVE_WEIGHT_ERROR:
      return { ...state, saveWeightInProgress: false, saveWeightError: payload };

    case CLEAR_FORM:
      return { ...state, clearForm: true };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const selectSaveWeightSuccess = state => state.ShippingDetailsPage.saveWeightSuccess;

export const selectSaveWeightInProgress = state => state.ShippingDetailsPage.saveWeightInProgress;

export const selectSaveWeightError = state => state.ShippingDetailsPage.saveWeightError;

// ================ Action creators ================ //

export const saveWeightRequest = () => ({ type: SAVE_WEIGHT_REQUEST });
export const saveWeightSuccess = () => ({ type: SAVE_WEIGHT_SUCCESS });
export const saveWeightError = error => ({ type: SAVE_WEIGHT_ERROR, payload: error });

export const clearForm = () => ({ type: CLEAR_FORM });

// ================ Thunks ================ //

export const saveWeightToAllListings = params => async (dispatch, getState, sdk) => {
  dispatch(saveWeightRequest());
  const isOwn = params?.isOwn;

  try {
    const response = await sdk.ownListings.query({});
    const listings = response?.data?.data;

    if (listings) {
      for (const listing of listings) {
        const updateParams = isOwn
          ? {
              shippingPriceInSubunitsOneItem: params?.shippingPriceInSubunitsOneItem?.amount,
              shippingPriceInSubunitsAdditionalItems: params?.shippingPriceInSubunitsOneItem?.amount,
              deliveryOptions: params?.deliveryOptions,
              shippingPreference: OWN,
            }
          : {
              ...shippingDefaultDimenstions,
              shippingPreference: SB_MARKET,
              shippingPriceInSubunitsOneItem: null,
              shippingPriceInSubunitsAdditionalItems: null,
              deliveryOptions: ['sbShipping'],
              weight: params?.weight,
              massUnit: params?.massUnit,
            };

        await sdk.ownListings.update({
          id: listing?.id?.uuid,
          publicData: { ...updateParams },
        });
      }
      dispatch(saveWeightSuccess());
      return RESPONSE.SUCCESS;
    }
  } catch (error) {
    dispatch(saveWeightError(error));
  } finally {
    dispatch(clearForm());
  }
};

export const loadData = () => fetchCurrentUser();
